/**
 * Virtual Component device action preparations.
 * Duplicated from Scenes for Flow independence.
 */

import type { DeviceAction } from 'src/types/DeviceActionUI';
import type { DeviceActionScript } from 'src/types/ScenesActionsTypes';
import type { PreparedDeviceAction } from '../types';

/** Inlined from Scenes virtual_component_utils for independence */
const isVCType = (type: string): boolean =>
	['button', 'number', 'boolean', 'enum', 'text'].includes(type);

/**
 * Convert Virtual Component Actions to IoTS
 */
export const prepareVCActionToIots = (
	device_id: string,
	decimal_id: number | string,
	actions: Array<DeviceAction>,
): PreparedDeviceAction | null => {
	const _action = actions[0];
	if (!_action) return null;

	const iots_action = _action.name + (1 + Number(_action.index ?? 0));

	let setValue: string | number;
	if (typeof _action.value === 'object' && _action.value !== null) {
		setValue = JSON.stringify(_action.value);
	} else {
		setValue = _action.value as string | number;
	}

	return {
		r: 'dev:' + decimal_id + ':' + iots_action,
		set: setValue,
		_gui_device_id: device_id,
		_gui_purpose: 'action',
	} as PreparedDeviceAction & DeviceActionScript;
};

export { isVCType };
